import React from "react";

import asIcon from "./asIcon";

export default asIcon(({ color }) => (
  <path fill={color} d="M86 85.3L62.6 56.4a29.2 29.2 0 1 0-8.1 5.8l.3.5 23.4 28.9a4.8 4.8 0 0 0 6.7.7l.4-.3a4.8 4.8 0 0 0 .7-6.7zM62.1 35.6a20.3 20.3 0 1 1-5.9-14.3 20.1 20.1 0 0 1 5.9 14.3z" />
));
